import { SettingsResponse } from "@/services/datatypes/api";
import { TYPO3_BASE_URL } from "@/services/globals";

export const useGetSettings = () => {
    const getSettings = async (jwt: string): Promise<SettingsResponse> => {
        //console.log("getSettings");
        const result = await fetch(`${TYPO3_BASE_URL}usersettings/?jwt=${jwt}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        //console.log("getSettings - result:", result);
        const responseJson = await result.json();
        const response: SettingsResponse = {
            ...responseJson,
            ok: result.ok,
        };
        //console.log("getSettings - response:", response);
        return response;
    }
    return { getSettings }
};

